var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect } from "react";
import SelectDropdown from "../../../../../../../shared-library/components/selectdropdown";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { useSelector } from "react-redux";
import { accountDetails } from "@salesdi";
import moment from "moment";
import { useNavigate } from "react-router-dom";
var ClientTierPopup = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var navigate = useNavigate();
    var _o = __read(React.useState([]), 2), clientTier = _o[0], setClientTier = _o[1];
    var _p = __read(React.useState([]), 2), clientTierReason = _p[0], setClientTierReason = _p[1];
    var _q = __read(React.useState({
        CurrentTier: props === null || props === void 0 ? void 0 : props.clientTier,
        RMFeedbackTier: "",
        ClientReason: "",
    }), 2), formData = _q[0], setFormData = _q[1];
    var _r = __read(React.useState({
        currentTierBody: false,
        currentTierBody1: false,
        statusRejected: false,
        statusExpired: false,
        statusapproved: false,
        normalFormFields: false,
        statuspendingforApprove: false,
    }), 2), clientTierCondition = _r[0], setClientTierCondition = _r[1];
    var _s = __read(React.useState(false), 2), clientConditionCheckData = _s[0], setClientConditionCheckData = _s[1];
    var _t = __read(React.useState(false), 2), clientConditionCheckData1 = _t[0], setClientConditionCheckData1 = _t[1];
    var _u = __read(React.useState(0), 2), requesterId = _u[0], setRequesterID = _u[1];
    var selectedAccount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var clientTierConditionFunction = function () {
        var _a, _b, _c, _d, _e;
        if ((props === null || props === void 0 ? void 0 : props.clientTier) === "Blue" ||
            (props === null || props === void 0 ? void 0 : props.clientTier) === "Bronze" ||
            (props === null || props === void 0 ? void 0 : props.clientTier) === "Silver" ||
            (props === null || props === void 0 ? void 0 : props.clientTier) === "" ||
            (props === null || props === void 0 ? void 0 : props.clientTier) === "NA") {
            setClientConditionCheckData(true);
            rmFeedbackTier();
            reasonTier();
            var todayDate = new Date();
            var newTodayDate = moment(todayDate).format("YYYY/MM/DD kk:mm:ss");
            var newCurrentDate = new Date(newTodayDate);
            var dateFormatResult = moment((_a = props === null || props === void 0 ? void 0 : props.clientTierCurrentTierStatusData) === null || _a === void 0 ? void 0 : _a.createdDate).format("YYYY/MM/DD kk:mm:ss");
            //let sentOnDate = new Date(props?.clientTierCurrentTierStatusData?.createdDate);
            // sentOnDate.setDate(sentOnDate.getDate());
            var newSentOnDate = new Date(dateFormatResult);
            var Time = newCurrentDate.getTime() - newSentOnDate.getTime();
            var Days = Time / (1000 * 3600 * 24);
            if (((_b = props === null || props === void 0 ? void 0 : props.clientTierCurrentTierStatusData) === null || _b === void 0 ? void 0 : _b.statusName) ===
                "Pending for Approval") {
                Days > 15
                    ? setClientTierCondition(__assign(__assign({}, clientTierCondition), { normalFormFields: true, currentTierBody1: true }))
                    : setClientTierCondition(__assign(__assign({}, clientTierCondition), { statuspendingforApprove: true, currentTierBody1: true }));
            }
            else if (((_c = props === null || props === void 0 ? void 0 : props.clientTierCurrentTierStatusData) === null || _c === void 0 ? void 0 : _c.statusName) === "Approved") {
                Days > 160
                    ? setClientTierCondition(__assign(__assign({}, clientTierCondition), { normalFormFields: true, currentTierBody1: true }))
                    : setClientTierCondition(__assign(__assign({}, clientTierCondition), { statusapproved: true, currentTierBody1: true }));
            }
            else if (((_d = props === null || props === void 0 ? void 0 : props.clientTierCurrentTierStatusData) === null || _d === void 0 ? void 0 : _d.statusName) === "Rejected") {
                Days > 15
                    ? setClientTierCondition(__assign(__assign({}, clientTierCondition), { normalFormFields: true, currentTierBody1: true }))
                    : setClientTierCondition(__assign(__assign({}, clientTierCondition), { statusRejected: true, currentTierBody: true, statusapproved: true }));
            }
            else if (((_e = props === null || props === void 0 ? void 0 : props.clientTierCurrentTierStatusData) === null || _e === void 0 ? void 0 : _e.statusName) === "Expired") {
                Days > 15
                    ? setClientTierCondition(__assign(__assign({}, clientTierCondition), { normalFormFields: true, currentTierBody1: true }))
                    : setClientTierCondition(__assign(__assign({}, clientTierCondition), { statusExpired: true, currentTierBody: true }));
            }
            else {
                setClientTierCondition(__assign(__assign({}, clientTierCondition), { normalFormFields: true, currentTierBody1: true }));
            }
        }
        else {
            setClientConditionCheckData1(true);
        }
    };
    var rmFeedbackTier = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, di.clients
                        .getClientTierList({ currentTier: props === null || props === void 0 ? void 0 : props.clientTier })
                        .then(function (ResponseClientTier) {
                        var clientTierData = ResponseClientTier.map(function (item) {
                            return {
                                value: item.id,
                                display: item.tier,
                            };
                        });
                        setClientTier(clientTierData);
                    })
                        .catch(function (error) {
                        console.log("client Tier", error);
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var reasonTier = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, di.clients
                        .getClientTierReasonList()
                        .then(function (ResponseClientTierReason) {
                        var clientTierReasonData = ResponseClientTierReason.map(function (item) {
                            return {
                                value: item.reasonID,
                                display: item.reason,
                            };
                        });
                        setClientTierReason(clientTierReasonData);
                    })
                        .catch(function (error) {
                        console.log("client tier", error);
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (event) {
        var _a;
        setFormData(__assign(__assign({}, formData), (_a = {}, _a[event.currentTarget.name] = event.currentTarget.value, _a)));
    };
    // useEffect(()=>{
    //   requesterIdData();
    // })
    var requesterIdData = function () {
        accountDetails.getSalesuserId().then(function (responseData) {
            if (responseData && responseData.length > 0) {
                setRequesterID(Number(responseData));
            }
        });
    };
    //let requestId = requesterIdData() && requesterIdData() != null ? requesterIdData() : 0;
    //console.log("requesterId data",requestId);
    var saveClientTierData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var requestSaveData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestSaveData = {
                        pan: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.pan,
                        requesterID: requesterId && requesterId != null ? requesterId : 0,
                        currentTier: formData === null || formData === void 0 ? void 0 : formData.CurrentTier,
                        rmSuggestedTier: Number(formData === null || formData === void 0 ? void 0 : formData.RMFeedbackTier),
                        reasonID: formData === null || formData === void 0 ? void 0 : formData.ClientReason,
                        statusID: 1,
                    };
                    return [4 /*yield*/, di.clients
                            .saveHomogenousPostRMFeedback(requestSaveData)
                            .then(function (responseSaveData) {
                            if (responseSaveData && responseSaveData.data.length > 0) {
                                alert("Changes Saved Successfully");
                                props.setTierPopup(false);
                                props.handleClientOverviewCall();
                            }
                        })
                            .catch(function (error) {
                            console.log("Save data", error);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (clientConditionCheckData) {
            props.setTierHeading("RM Request for Tier change");
        }
        else if (clientConditionCheckData1) {
            props.setTierHeading("Tier above gold cannot be upgraded");
        }
        else {
            props.setTierHeading("");
        }
    }, [clientConditionCheckData, clientConditionCheckData1]);
    useEffect(function () {
        if (selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode)
            clientTierConditionFunction();
        requesterIdData();
    }, [selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "client-tier" },
            React.createElement(React.Fragment, null, clientConditionCheckData === true ? (React.createElement(React.Fragment, null, clientTierCondition.currentTierBody === true ? (React.createElement("br", null,
                React.createElement("label", { className: "pb-4 DMSan_14_500 txt_blackOne1" },
                    "Applicable Details",
                    " "),
                React.createElement("br", null),
                clientTierCondition.statusRejected === true && (React.createElement("span", null,
                    "Your last request Rejected.You can raise new request form 1st to 15th of every month.",
                    " ")),
                clientTierCondition.statusExpired === true && (React.createElement("span", null,
                    "Your last request Expired.You can raise new request form 1st to 15th of every month.",
                    " ")))) : (clientTierCondition.currentTierBody1 === true && (React.createElement(React.Fragment, null,
                " ",
                React.createElement("label", { className: "pb-4 DMSan_14_500 txt_blackOne1" },
                    " ",
                    "Applicable Details",
                    " "),
                React.createElement("br", null),
                clientTierCondition.statusapproved === true && (React.createElement("span", null,
                    " ",
                    "Cannot Update Tier since Last Update through RM Feedback was performed less than 6 months back.Please contact CLC team for further details")),
                clientTierCondition.normalFormFields === true ? (React.createElement(React.Fragment, null,
                    " ",
                    React.createElement("table", null,
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("td", { className: "DMSans_16_500 txt-midnight-blue" },
                                    " ",
                                    "Current Tier"),
                                React.createElement("td", { className: "DMSans_16_500 client leadpage-selectdropdown " },
                                    React.createElement(SelectDropdown, { name: "CurrentTier", dropdownOptions: [], placeholderClassName: "holder leadselect-holder", className: "basic-multi-select DMSanN_16_400 client-color  " +
                                            ((_a = props === null || props === void 0 ? void 0 : props.clientTier) === null || _a === void 0 ? void 0 : _a.toLowerCase()), disabled: true, placeholder: props === null || props === void 0 ? void 0 : props.clientTier, onChangeEvent: handleChange, defaultValue: formData === null || formData === void 0 ? void 0 : formData.CurrentTier }))),
                            React.createElement("tr", null,
                                React.createElement("td", { className: "DMSans_16_500 txt-midnight-blue" }, "RM Requested Tier"),
                                React.createElement("td", { className: "leadpage-selectdropdown" },
                                    React.createElement(SelectDropdown, { name: "RMFeedbackTier", dropdownOptions: clientTier, downarrow: "edel-icon-arrow-down", placeholderClassName: "holder leadselect-holder", className: "basic-multi-select DMSanN_16_400 txt_black-seven", placeholder: "Select Tier", onChangeEvent: handleChange, defaultValue: formData === null || formData === void 0 ? void 0 : formData.RMFeedbackTier }))),
                            React.createElement("tr", null,
                                React.createElement("td", { className: "DMSans_16_500 txt-midnight-blue" }, "Reason"),
                                React.createElement("td", { className: "leadpage-selectdropdown" },
                                    React.createElement(SelectDropdown, { name: "ClientReason", dropdownOptions: clientTierReason, placeholder: "Select Reason", downarrow: "edel-icon-arrow-down", placeholderClassName: "holder leadselect-holder", className: "basic-multi-select DMSanN_16_400", onChangeEvent: handleChange, defaultValue: formData === null || formData === void 0 ? void 0 : formData.ClientReason }))))),
                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Submit", className: "mt-4 w-25", onClick: function () { return saveClientTierData(); } }))) : clientTierCondition.statuspendingforApprove === true ? (React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { className: "DMSans_16_500 txt-midnight-blue" },
                                " ",
                                "Current Tier"),
                            React.createElement("td", { className: "DMSans_16_500 client leadpage-selectdropdown " },
                                React.createElement(SelectDropdown, { name: "CurrentTier", dropdownOptions: [], placeholderClassName: "holder leadselect-holder", className: "basic-multi-select DMSanN_16_400 client-color  " +
                                        ((_c = (_b = props === null || props === void 0 ? void 0 : props.clientTierCurrentTierStatusData) === null || _b === void 0 ? void 0 : _b.currentTier) === null || _c === void 0 ? void 0 : _c.toLowerCase()), disabled: true, placeholder: (_d = props === null || props === void 0 ? void 0 : props.clientTierCurrentTierStatusData) === null || _d === void 0 ? void 0 : _d.currentTier, onChangeEvent: handleChange, defaultValue: formData === null || formData === void 0 ? void 0 : formData.CurrentTier }))),
                        React.createElement("tr", null,
                            React.createElement("td", { className: "DMSans_16_500 txt-midnight-blue" }, "RM Requested Tier"),
                            React.createElement("td", { className: "leadpage-selectdropdown" },
                                React.createElement(SelectDropdown, { name: "RMFeedbackTier", dropdownOptions: clientTier, downarrow: "edel-icon-arrow-down", placeholderClassName: "holder leadselect-holder", className: "basic-multi-select DMSanN_16_400 txt_black-seven", placeholder: "Select Tier", disabled: true, onChangeEvent: handleChange, defaultValue: ((_e = clientTier.filter(function (x) {
                                        var _a;
                                        return x.display ==
                                            ((_a = props === null || props === void 0 ? void 0 : props.clientTierCurrentTierStatusData) === null || _a === void 0 ? void 0 : _a.suggestedTier);
                                    })[0]) === null || _e === void 0 ? void 0 : _e.value) || "" }))),
                        React.createElement("tr", null,
                            React.createElement("td", { className: "DMSans_16_500 txt-midnight-blue" }, "Status"),
                            React.createElement("td", { className: "leadpage-selectdropdown" }, (_f = props === null || props === void 0 ? void 0 : props.clientTierCurrentTierStatusData) === null || _f === void 0 ? void 0 : _f.statusName)),
                        React.createElement("tr", null,
                            React.createElement("td", { className: "DMSans_16_500 txt-midnight-blue" }, "Pending With"),
                            React.createElement("td", { className: "leadpage-selectdropdown" }, (_g = props === null || props === void 0 ? void 0 : props.clientTierCurrentTierStatusData) === null || _g === void 0 ? void 0 : _g.raName)),
                        React.createElement("tr", null,
                            React.createElement("td", { className: "DMSans_16_500 txt-midnight-blue" }, "Request Raised Date Time"),
                            React.createElement("td", { className: "leadpage-selectdropdown" }, ((_h = props === null || props === void 0 ? void 0 : props.clientTierCurrentTierStatusData) === null || _h === void 0 ? void 0 : _h.createdDate) &&
                                moment((_j = props === null || props === void 0 ? void 0 : props.clientTierCurrentTierStatusData) === null || _j === void 0 ? void 0 : _j.createdDate).format("DD/MM/YYYY HH:MM")))))) : (clientTierCondition.statusapproved === true && (React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { className: "DMSans_16_500 txt-midnight-blue" },
                                " ",
                                "Last Updated Date"),
                            React.createElement("td", { className: "DMSans_16_500 client leadpage-selectdropdown " }, moment((_k = props === null || props === void 0 ? void 0 : props.clientTierCurrentTierStatusData) === null || _k === void 0 ? void 0 : _k.updatedDate).format("DD/MM/YYYY HH:MM"))),
                        React.createElement("tr", null,
                            React.createElement("td", { className: "DMSans_16_500 txt-midnight-blue" }, "Last Request Raised By"),
                            React.createElement("td", { className: "leadpage-selectdropdown" }, (_l = props === null || props === void 0 ? void 0 : props.clientTierCurrentTierStatusData) === null || _l === void 0 ? void 0 : _l.rmName)),
                        React.createElement("tr", null,
                            React.createElement("td", { className: "DMSans_16_500 txt-midnight-blue" }, "Last Request Approved By"),
                            React.createElement("td", { className: "leadpage-selectdropdown" }, (_m = props === null || props === void 0 ? void 0 : props.clientTierCurrentTierStatusData) === null || _m === void 0 ? void 0 : _m.raName))))))))))) : (React.createElement(React.Fragment, null))))));
};
export default ClientTierPopup;
